import { Component, ViewChild, ElementRef } from '@angular/core';
import { FormControl, FormGroup, FormBuilder } from '@angular/forms';

import { MatDatepicker } from '@angular/material';
import { AppService } from '../../../app.service';
import { SearchService } from './search.service';
import { ConfirmService } from '../../confirm/confirm.service';
import { ActivatedRoute } from '@angular/router'; 
import { formatDate } from '@angular/common';
import { Globals } from '../../../globals';
import { NgxSmartModalService } from 'ngx-smart-modal';
import customerJson from "../../../../assets/config/customer.json";
import translateJson from "../../../../translate.json";
import { SearchDropdownComponent } from '../../input/SearchableDropdown/search.dropdown.component';
import { Countries } from '../../../shared/countries/countries';
import { AuthenticationService } from '../../../auth';

/** Enums */
import { SuaStatusType } from '../../enum/SuaStatusType';
import { ProjectSuaStatusType } from '../../enum/ProjectSuaStatusType';
import { EmployerType } from '../../enum/EmployerType'
import { ExportTypes } from '../../enum/ExportTypes';

@Component({
  selector: 'search-comp',
  providers: [AppService, ConfirmService, SearchService, Countries, AuthenticationService], 
  templateUrl: './search.component.html',  
  styleUrls: ['./search.component.css']  
})

export class SearchComponent {

  @ViewChild(SearchDropdownComponent) searchDropdown: SearchDropdownComponent;

  // Get translation/text from customerJson
  private i18 = translateJson.i18;
  private customerOrgId: String = customerJson.customer.organisationId

  private edition = customerJson.edition;
  private allowExportDigitalXml: boolean = customerJson.settings.enableDigitalXmlExport;

  /* Boolean state variables */
  private exportOldForms: Boolean = false;
  showLoader: Boolean = false;
  ready: Boolean = false;
  hasSearchResult: Boolean = false;
  modalData: string[] = ["", ""];
  confirmModalBool: Boolean = false;
  disallowExport: Boolean = true;

  /* Query-handling */
  avaliableParameters: any;
  chosenParameter: any = {};
  inbetweenOperator: String = "AND";
  filterList: any = [];
  actualFilterList: any = [];
  persistedFilterList: any = [];
  doubleParameter: boolean = false;
  orAndInputDisabled: boolean = true;

  exportedDocuments: Array<Object> = [{name: String, id: String}];
  exportedXml: {name: String, type: String, id:String};

  /* Pageable */
  pager: any = {};
  pageable: any = {data: {totalElements: 0}};
  page: number = 1;
  pageSize: string = "25"; // Amount of items before showing pagination  
  pageArray: number[] = [];
  pageTotalArray: number[] = []; 
  pageStartIndex: number = 0;
  pageEndIndex: number = 0;
  pageAmountOfIndex: number = 0;

  /* Forms */
  searchForm: FormGroup;
  pageSizeForm: FormGroup;

  /* Entity-specific vars */
  type: String;
  verboseType: String;
  addString: String;

  /* List of search-results */
  results: any = [];
  rkIdToExport: any = [];

  showDropdownDisabled: boolean = true;
  exportListModalActive: boolean = customerJson.settings.exportListWithNameModal;
  exportListDepartmentName: string;
  exportOnlyValid: boolean = true;
  reportMultiFile: boolean = true;

  /* Enums */
  suaStatusType = SuaStatusType;
  projectSuaStatusType = ProjectSuaStatusType;
  employerType = EmployerType;
  exportTypes = ExportTypes;

  departmentsList: any = [];
  searchDropdownList: Array<string> = [];

  isGovernment = customerJson.edition === 'government' ? true : false;
  isCompany = customerJson.edition === 'company' ? true : false;
  searchResultAmount: number = 0;
  totalExported: number = 0;
  successfullExport: number = 0;
  failedExport: number = 0;
  missingInformation: number = 0;
  exportModalType: string;
  lastViewedPage: number = 1;
  scrollToAnchor: boolean = false;
  lastViewedAnchor: string = '';

  @ViewChild('parameter') parameterFocuser: ElementRef;
  @ViewChild('operator') operatorFocuser: ElementRef;
  @ViewChild('integer') integerFocuser: ElementRef;
  @ViewChild('filterDateInput') dateFocuser: MatDatepicker<Date>;
  @ViewChild('selectable') selectableFocuser: ElementRef;
  @ViewChild('searchResult') searchResultFocuser;

  constructor(
    private service: SearchService,
    private confirmService: ConfirmService,
    private activatedRoute: ActivatedRoute,
    private appService: AppService,
    private ngxSmartModalService: NgxSmartModalService,
    private formBuilder: FormBuilder,
    private route:ActivatedRoute,       
    private globals: Globals,
    private countries: Countries,
    private authService: AuthenticationService) {
      this.authService.isAuthenticated();
      this.exportOldForms = customerJson.settings.exportOldForms;
      route.params.subscribe(val => {

        this.ready = false;
        this.disallowExport = true;
        this.showDropdownDisabled = true;
        this.type = this.activatedRoute.snapshot.paramMap.get('type');
        this.avaliableParameters = [];
        this.filterList = [];
        this.actualFilterList = [];
        this.lastViewedPage = 1;
        this.lastViewedAnchor = '';
        this.scrollToAnchor = false;
        this.setDefault();
        this.searchForm.patchValue({
          operatorInput: this.i18.search.form.searchOperatorSelect,
          orAndInput: "---"
        });
        this.pageable.data = {
          totalElements: 0
        }
        if(localStorage.getItem('pageSize') != undefined) {
          this.pageSize = localStorage.getItem('pageSize');
          this.pageSizeForm.patchValue({
            pageSizeInput: this.pageSize
          })
        } else {
          localStorage.setItem('pageSize', this.pageSize);
          this.pageSizeForm.patchValue({
            pageSizeInput: this.pageSize
          })
        }

        if(JSON.parse(localStorage.getItem('lastComponent')) == this.type) {
          this.actualFilterList = JSON.parse(localStorage.getItem('lastSearch'));
          this.filterList = JSON.parse(localStorage.getItem('filterList'));
          this.lastViewedPage = JSON.parse(localStorage.getItem('lastViewedPage'));
          this.lastViewedAnchor = JSON.parse(localStorage.getItem('lastViewedAnchor')); 
          if(this.lastViewedPage != null) {
            this.setPaginationPage(this.lastViewedPage);
          } else {
            this.search();
          }
        } else {
          localStorage.setItem('lastComponent', JSON.stringify(this.type));
          this.clearAnchor();
          this.search();
        }
        this.ready = true;
    });
  }   

  getSearchSuggestions() {
    this.service.getSearchSuggestions(this.chosenParameter.id).subscribe(
      data => this.searchDropdownList = data,
      error => console.error(error)
    )
  }

  ngAfterViewInit() {
    if(!this.scrollToAnchor && (this.lastViewedAnchor == null || this.lastViewedAnchor === '')){
      this.parameterFocuser.nativeElement.focus();
    }
  }

  /**
   * Set the route to a new desired route
   * @param route
   */
  setRoute(route) {
    this.appService.setRoute(route);
    localStorage.setItem('lastComponent', JSON.stringify(this.type));
    localStorage.setItem('lastSearch', JSON.stringify(this.actualFilterList));
    localStorage.setItem('filterList', JSON.stringify(this.filterList));
    localStorage.setItem('lastViewedPage', JSON.stringify(this.page));
  }

  /**
   * Set default values
   */
  setDefault() {
    this.hasSearchResult = false;
 
    if(this.type === 'person') {
        this.addString = this.i18.search.form.newPerson;
        this.verboseType = this.i18.search.form.newPersonVerboseType;
    } else if(this.type === 'employer') {
        this.addString = this.i18.search.form.newOrganisation;
        this.verboseType = this.i18.search.form.newOrganisationVerboseType;
    } else if (this.type == 'project'){
        this.addString = this.i18.search.form.newProject;
        this.verboseType = this.i18.search.form.newProjectVerboseType;
    } else if (this.type == 'registercontrol'){
        this.addString = this.i18.search.form.newRk;
        this.verboseType = this.i18.search.form.newRkVerboseType;
    } else if (this.type == 'securityAgreement') {
        this.addString = this.i18.search.form.newFas;
        this.verboseType = this.i18.search.form.newFasVerboseType;
    } else {
        this.setRoute("home");
    } 

    this.searchForm = new FormGroup({
      orAndInput: new FormControl(),
      parameterInput: new FormControl(),
      operatorInput: new FormControl(),
      filterTextInput: new FormControl(),
      filterIntegerInput: new FormControl(),
      filterSelectableInput: new FormControl(),
      filterDateInput: new FormControl(),
      filterCountryCodeInput: new FormControl(),
      noneInput: new FormControl()
    });
    this.pageSizeForm = new FormGroup({
      pageSizeInput: new FormControl()
    })

    this.page = 1;

    this.service.getParametersByType(this.type)
      .subscribe(
        data => this.setAvaliableParameters(data), 
        error =>  this.showError(error.error),  
        () => this.showLoader = false      
        );
        
    this.chosenParameter.inputType = null;
    this.searchForm.get('operatorInput').disable();
    this.searchForm.get('filterTextInput').disable();
    this.searchForm.get('filterIntegerInput').disable();
    this.searchForm.get('filterSelectableInput').disable();
    this.searchForm.get('filterDateInput').disable();
    this.searchForm.get('noneInput').disable();
    this.searchForm.get('filterCountryCodeInput').disable();
    this.orAndInputDisabled = true;
  }

  /**
   * Assign the avaliable parameters recieved from back-end
   * @param parameterList List of avaliable parameters 
   */
  setAvaliableParameters(parameterList) {
        this.avaliableParameters = parameterList;
    for(let parameter of this.avaliableParameters) {
      parameter.displayName = this.appService.getTranslateValueFromKeyStr(parameter.translateName, parameter.verboseName);
    }
    this.avaliableParameters.sort((a, b) => a.displayName.localeCompare(b.displayName, 'sv', {sensitivity: 'case'}));
    this.searchForm.get('operatorInput').disable(); // verka behövs för att disabla operatorns rulllistan
    
  }

  /**
   * Temporarily set the orAnd variable
   * @param orAnd 
   */
  setOrAnd(orAnd) {
    this.inbetweenOperator = orAnd;
    this.setDoubleParameter();
  }

  exportResult(format, component, exportOnlyValid, reportMultiFile) {
    if(this.exportListDepartmentName === null || this.exportListDepartmentName === undefined){
      this.exportListDepartmentName = this.i18.goverment.form.govermentNotSelected;
    }
    this.persistedFilterList = Object.assign([], this.actualFilterList);
    this.showLoader = true

    this.service.exportSearchResult(this.persistedFilterList, format, component, this.exportListDepartmentName, exportOnlyValid, reportMultiFile)
      .subscribe(
        data => {
          this.showStatusModal(data),
          this.exportListDepartmentName = null,
          this.calculateExports(data)
          this.showLoader = false
        }, 
        error =>  this.showError(error),  
        () => this.showLoader = false
    );
  }

  /**
   * Set a new page size and refresh the result-list
   * @param pageSize the new number of results per pagination-page
   */
  setNewPageSize(pageSize) {
    this.pageSize = pageSize;
    localStorage.setItem('pageSize', this.pageSize);
    this.page = 1;
    this.search();
  }

  /**
   * Display confirm modal when exporting
   * @param format 
   * @param component 
   */
  showConfirmModal(format, component) {
    this.searchResultAmount = this.pageable.data.totalElements;
    this.exportModalType = component;

    if(this.exportListModalActive && component === this.exportTypes.REPORT_LIST_PDF && format === 'pdf') {
      this.service.getAllDepartments()
        .subscribe(
          data => this.setDepartmentsList(data),
          error => this.showError(error.error)
        )
    }

    // Always true if export of XML and when opening a new modal     
    this.exportOnlyValid = component != this.exportTypes.REPORT_LIST_XML && format === 'xml' ? true : false;
    this.reportMultiFile = component === this.exportTypes.REPORT_LIST_XML && format === 'xml' ? true : false;
    this.modalData = [format, component, this.pageable.data.totalElements];
    this.ngxSmartModalService.setModalData(this.modalData, 'confirmModal', true);
    this.ngxSmartModalService.getModal('confirmModal').open();
  }


  showStatusModal(status) {
    let modalData: any = [];
    if(status != null && status.length > 0 && (status.type === this.exportTypes.RK_XML || status.type === this.exportTypes.REPORT_LIST_XML)) {
      this.exportedXml = status;
      modalData[0] = status.type;
    } else if (status != null && status.length > 0){
      this.exportedDocuments = status;
      modalData[0] = status[0].type;
      modalData[1] = this.exportedDocuments.length;
    }
    
    this.ngxSmartModalService.setModalData(modalData, 'statusModal', true);
    this.ngxSmartModalService.getModal('statusModal').open();
    this.search();
  }

  /**
   * Select the parameter chosen in the drop-down
   * @param parameter the name of the parameter chosen in the drop-down
   */
  setChosenParameter(parameter) {
    for(let forParameter of this.avaliableParameters) {
      if(forParameter.id === parameter) {
        this.chosenParameter = Object.assign({}, forParameter);
        for(let operator of this.chosenParameter.operators){
          operator.displayName = this.appService.getTranslateValueFromKeyStr(operator.translateName, operator.verboseName);
        }

        for (let selectable of this.chosenParameter.selectables) {
          selectable.displayName = this.appService.getTranslateValueFromKeyStr(selectable.translateName, selectable.verboseName);
          
          if (this.type === 'registercontrol' /*&& this.chosenParameter.verboseName === this.i18.searchParameters.rk.status*/) {
          // FIXME: Quickfix to show appropriate rk status names. Should be replaced with new backend functionality
            if (selectable.value === this.suaStatusType.NOT_SENT) {
              selectable.displayName = this.i18.searchParameters.selectable.rkStatus1
            }

            if (selectable.value === this.suaStatusType.SENT) {
              selectable.displayName = this.i18.searchParameters.selectable.rkStatus2
            }
            if (selectable.value === this.suaStatusType.APPROVED) {
              selectable.displayName = this.i18.searchParameters.selectable.rkStatus3
            }
            if (selectable.value === this.suaStatusType.CANCELLED) {
              selectable.displayName = this.i18.searchParameters.selectable.rkStatus4
            }

            if (selectable.value === this.suaStatusType.REPORT) {
              selectable.displayName = this.i18.searchParameters.selectable.rkStatus5
            }

            if (selectable.value === this.suaStatusType.REPORTED) {
              selectable.displayName = this.i18.searchParameters.selectable.rkStatus6
            }
            if (selectable.value === this.suaStatusType.DENIED) {
              selectable.displayName = this.i18.searchParameters.selectable.rkStatus7
            }
          }
        }
        // FIXME: end of fixme note
      }
    }
    


    if(this.chosenParameter != null){
      if(this.chosenParameter.operators != null){
        this.chosenParameter.operators.sort((a, b) => a.displayName.localeCompare(b.displayName, 'sv', {sensitivity: 'case'}));
      }
      if(this.chosenParameter.selectables != null) {
        this.chosenParameter.selectables.sort((a, b) => a.displayName.localeCompare(b.displayName, 'sv', {sensitivity: 'case'}));
      }
    }
    if(this.chosenParameter.operators.length === 1) {
      setTimeout(() => {
        this.setChosenOperator(this.chosenParameter.operators[0].id);
        this.searchForm.get('operatorInput').disable();
      }, 1);
      
    }
    if(this.chosenParameter.operators.length === 2) {
      let defaulOperator = this.chosenParameter.operators.findIndex(op => op.name == 'contains')
      if(defaulOperator > -1){
        setTimeout(() => {
          this.setChosenOperator(this.chosenParameter.operators[defaulOperator].id);
        }, 1);
      } else {
        setTimeout(() => {
          this.setChosenOperator(this.chosenParameter.operators[0].id);
        }, 1);
      }
      this.searchForm.get('operatorInput').enable();
      
    } else {
      this.searchForm.get('operatorInput').enable();
      this.searchForm.patchValue({operatorInput: 'null'})
      this.operatorFocuser.nativeElement.focus();
    }
    this.searchForm.patchValue({
      filterTextInput: "",
      filterIntegerInput: "",
      filterDateInput: "",
      filterSelectableInput: "null",
      filterCountryCodeInput: "",
    });
  }

  /**
   * Select the operator chosen in the drop-down
   * @param operator the name of the operator chosen in the drop-down
   */
  setChosenOperator(operator) {

    for(let forOperator of this.chosenParameter.operators) {
      if(forOperator.id === operator) {
        this.chosenParameter.chosenOperator = forOperator;
      }
    }

    this.searchForm.patchValue({operatorInput: this.chosenParameter.chosenOperator.id});
    this.setDoubleParameter();

    this.searchForm.get('filterTextInput').disable();
    this.searchForm.get('filterIntegerInput').disable();
    this.searchForm.get('filterSelectableInput').disable();
    this.searchForm.get('filterDateInput').disable();
    this.searchForm.get('noneInput').disable();
    this.searchForm.get('filterCountryCodeInput').disable();

    if(this.chosenParameter.inputType === "text") {
      this.searchForm.get('filterTextInput').enable();
      
      this.resetSearchDropdownList();
      if (this.chosenParameter.fetchSuggestions) {
        this.getSearchSuggestions()
      }

      this.searchDropdown.focus();
    } else if(this.chosenParameter.inputType === "countryCode") {
      this.searchForm.get('filterCountryCodeInput').enable();
      this.searchDropdown.focus();
    } else if(this.chosenParameter.inputType === "integer") {
      this.searchForm.get('filterIntegerInput').enable();
      this.integerFocuser.nativeElement.focus();
    } else if(this.chosenParameter.inputType === "selectable") {
      this.searchForm.get('filterSelectableInput').enable();
      this.selectableFocuser.nativeElement.focus();
    } else if(this.chosenParameter.inputType === "date") {
      this.searchForm.get('filterDateInput').enable();
      this.dateFocuser.open();
    }
  }

  /**
   * Clears the dropdown list, setting its value to an empty array.
   */
  resetSearchDropdownList(): void {
    this.searchDropdownList = [];
  }

  /**
   * Updates the doubleParameter boolean to disable Add filter button in
   * order to prevent the user from adding nearly identical filters
   * conflicting with each others
   */
  setDoubleParameter() {
    let tmpCheck = false;

    if(this.inbetweenOperator != "OR") {
      if(this.actualFilterList != null && this.actualFilterList != undefined) {
        for(let forParameter of this.actualFilterList) {
          if(forParameter.id === this.chosenParameter.id) {
              if (forParameter.chosenOperator.id === this.chosenParameter.chosenOperator.id) {
                this.doubleParameter = true;
                tmpCheck = true;
            }
          }
        }
      }
    }

    if(!tmpCheck) {
      this.doubleParameter = false;
    }

  }

  /**
   * Select the selectable chosen in the drop-down in the case that the chosen parameter is of the type "selectable"
   * @param selectable the name of the selectable chosen in the drop-down
   */
  setSelectedSelectable(selectable) {
    for(let forSelectable of this.chosenParameter.selectables) {
      if(forSelectable.id === selectable) {
        this.chosenParameter.selectedSelectable = {id: forSelectable.id};
      }
    }
  }

  /**
   * Function for manually conducting a search. Not used at the moment but could come to use if we would like to change the search-functionality
   */
  searchButton() {
    if(this.actualFilterList.length > 0) {
      this.page = 1;
      this.search();
    }
  }

  /**
   * Conduct the search and call the appropriate functions for setting the results and displaying them
   */
  search() {
    this.persistedFilterList = Object.assign([], this.actualFilterList);
    if(this.persistedFilterList.length > 0) {
      this.showDropdownDisabled = false;
      this.disallowExport = false;
    }
    this.showLoader = true;
    this.hasSearchResult = false;
    this.service.search(this.type, this.persistedFilterList, this.page, this.pageSize)
      .subscribe(
        data =>  {
                  this.showLoader = false;
                  this.displayData(data);
                }, 
        error =>  { 
                  this.showError(error);
                  this.showLoader = false;
                }
        );
    this.hasSearchResult = true;
  }

  downloadProjectForm(uuid, fileName, type) {
    if(type === this.exportTypes.RK_PDF 
      || type === this.exportTypes.SUA_PDF 
      || type === this.exportTypes.REPORT_LIST_PDF) {
      this.service.getPdfStream(uuid, type)
      .subscribe(
        data => this.startPdfDownload(data, fileName),
        error => console.log(error)
      );
    } else if (type === this.exportTypes.RK_XML || type === this.exportTypes.REPORT_LIST_XML || type === this.exportTypes.SUA_XML) {
      this.service.getPdfStream(uuid, type)
      .subscribe(
        data => this.startXmlDownload(data, fileName),
        error => console.log(error)
      );
    }
  }

  startXmlDownload(data, fileName) {
    if(window.navigator.msSaveOrOpenBlob) {
      window.navigator.msSaveBlob(data, fileName + ".xml");
    } else {
      const url = window.URL.createObjectURL(data);
      const anchor = document.createElement("a");
      anchor.href = url;
      anchor.download = fileName + ".xml";
      document.body.appendChild(anchor);
      anchor.click();
      document.body.removeChild(anchor);
    }
  }

  startPdfDownload(data, fileName) {
    if(window.navigator.msSaveOrOpenBlob) {
      window.navigator.msSaveBlob(data, fileName + ".pdf");
    } else {
      const url = window.URL.createObjectURL(data);
      const anchor = document.createElement("a");
      anchor.href = url;
      anchor.download = fileName + ".pdf";
      document.body.appendChild(anchor);
      anchor.click();
      document.body.removeChild(anchor);
    }
  }

  /**
   * Sett all pagination-variables to their correct values and set the resulting data to the result array so that it can be displayed
   * @param data the data recieved from the back-end
   */
  displayData(data) {
    this.results = data.content;
    this.pageable.data = {
      pageable: data.pageable,
      totalElements: data.totalElements,
      numberOfElements: data.numberOfElements,
      totalPages: data.totalPages,
      first: data.first,
      last: data.last
    }
    this.setPageArray();
  }

  /**
   * Add a new filter to the search and refresh the search based on this new parameter
   * @param text the input from the text-field in the case of the parameter being of the type 'text'
   * @param integer the input from the integer-field in the case of the parameter being of the type 'integer'
   * @param date the input from the date-field in the case of the parameter being of the type 'date'
   * @param selectable the input from the selectable-field in the case of the parameter being of the type 'selectable'
   */
  addFilter(text, integer, date, selectable, countryCodeInput) {
    if(!(
           ((text       === undefined || text       === '') && 
            (integer    === undefined || integer    === '') &&
            (date       === undefined || date       === '') &&
            (selectable === undefined || selectable === '' || selectable === 'null') &&
            (countryCodeInput === undefined || countryCodeInput === '')) ||
            this.doubleParameter === true
      ))
      {
        let paramError = false;
        let param = this.chosenParameter.displayName + " " + this.chosenParameter.chosenOperator.displayName + " ";
        if(this.chosenParameter.inputType === "text") {
          param = param + text;
          this.chosenParameter.input = text;
        } else if (this.chosenParameter.inputType === "integer") {
          param = param + integer;
          this.chosenParameter.input = integer;
        } else if (this.chosenParameter.inputType === "date") {
          param = param + formatDate(date, 'yyyy-MM-dd', 'en'),
          this.chosenParameter.input = formatDate(date, 'yyyy-MM-dd', 'en');
        } else if (this.chosenParameter.inputType === "selectable") {
          let selectedSelectable = this.chosenParameter.selectables.find(item => item.id === selectable);
          param = param + selectedSelectable.displayName;
        } else if (this.chosenParameter.inputType === "countryCode") {
          let countryCode = this.countries.getEmployerCountryFromName(countryCodeInput)
          if(countryCode == null){
            this.confirmService.error(this.appService.getTranslatedErrorMessageFromArray('700'));
            paramError = true;
          } else {
            param = param + countryCode.name;
            this.chosenParameter.input = countryCode.code2;
          }
        }

        if (this.filterList != null && this.filterList.length != 0) {
          if (this.inbetweenOperator === 'OR') {
            this.filterList.push(this.i18.search.form.searchOrSelect);
          } else if (this.inbetweenOperator === 'AND') {
            this.filterList.push(this.i18.search.form.searchAndSelect);
          }
          this.chosenParameter.orAnd = this.inbetweenOperator
        }

        if(!paramError) {
          if(this.filterList !== null) {
            this.filterList.push(param);
          }
          if(this.actualFilterList !== null) {
            this.actualFilterList.push(this.chosenParameter);
          }
          this.chosenParameter = {};
          this.searchForm.patchValue({
            parameterInput: this.i18.search.form.searchChoseSelect,
            operatorInput: this.i18.search.form.searchOperatorSelect,
            orAndInput: 'AND'
          });
          this.searchForm.get('filterTextInput').disable();
          this.searchForm.get('filterIntegerInput').disable();
          this.searchForm.get('filterSelectableInput').disable();
          this.searchForm.get('filterDateInput').disable();
          this.searchForm.get('operatorInput').disable();
          this.searchForm.get('filterCountryCodeInput').disable();
          this.orAndInputDisabled = false;
          this.chosenParameter.inputType = null;

          this.setOrAnd('AND');
          this.page = 1;
          this.search();
        } else {
          if(this.filterList.length > 0 && this.filterList.length - 1 > 0) {
            this.filterList.pop(this.filterList.length - 1)
          }
        }
        this.searchForm.patchValue({parameterInput: 'null'})
        
    }
  }

  /**
   * Remove a filter from the search and refresh the results to keep them up to date
   * @param filterToRemove the index of the filter to remove in the visual filterlist. Requires some calculations to remove the correct filterbubbles and actual filters
   */
  removeFilter(filterToRemove) {
    if(filterToRemove === 0) {
      this.filterList.splice(filterToRemove, 2);
      this.actualFilterList.splice(filterToRemove, 1);
    } else {
      this.filterList.splice(filterToRemove-1, 2);
      this.actualFilterList.splice(filterToRemove/2, 1);
    } 

    if(this.actualFilterList.length === 0) {
      this.searchForm.patchValue({
        orAndInput: "---"
      });
      this.orAndInputDisabled = true;
      this.disallowExport = true;
    }

    if(this.actualFilterList === 0) {
      this.showDropdownDisabled = true;
      this.hasSearchResult = false;
      this.disallowExport = true;
    }
    this.search();
    this.setDoubleParameter();
  }

  /**
   * Set pagination array to be able to use *ngFor
   * Also calculate the pagination 
   */
  setPageArray() {
    if (this.page < 1 || this.page > this.pageable.data.totalPages) {
      return;
    }

    if (this.pageable.data.totalPages > 9) {
      this.pageAmountOfIndex = 9;
    } else {
      this.pageAmountOfIndex = this.pageable.totalPages;
    }

    if(this.pageTotalArray.length != this.pageable.data.totalPages) {
      this.pageTotalArray = [];
      for(var i = 0; i < this.pageable.data.totalPages; i++){
        this.pageTotalArray.push(i);
      }
    }

    if (this.pageable.data.totalPages < 10) {
      this.pageStartIndex = 0;
      this.pageEndIndex = this.pageable.data.totalPages;
    } else if (this.pageable.data.pageable.pageNumber - 4 < 0) {
      this.pageStartIndex = 0;
      this.pageEndIndex = 9;
    } else if (this.pageable.data.pageable.pageNumber + 5 > this.pageable.data.totalPages) {
      this.pageStartIndex = this.pageable.data.totalPages - 9;
      this.pageEndIndex = this.pageable.data.totalPages;
    } else {
      this.pageStartIndex = this.pageable.data.pageable.pageNumber - 4;
      this.pageEndIndex = this.pageable.data.pageable.pageNumber + 5;
    }

    this.pageArray = this.pageTotalArray.slice(this.pageStartIndex, this.pageEndIndex);   
  }

  /**
   * Set pagination on search result
   * @param page number of current page 
   */
  setPaginationPage(page: number) {
    if (page < 1 || page > this.pager.totalPages) {
        return;
    }
    this.page = page;

    if(JSON.parse(localStorage.getItem('lastComponent')) !== this.type || this.page != this.lastViewedPage) {
      this.clearAnchor();
    }
    this.search();
  }

  /**
   * Show error
   * @param error error text
   */
  showError(error) {
    if(error != undefined &&error != null) {
      this.confirmService.error(this.appService.getTranslatedErrorMessage(error));
    } else {
      let errorString = this.i18.general.genericError;   
      this.confirmService.error(errorString);
    }
    this.showLoader = false;
  }

  /**
   * Function for automatically formatting the ssn if the user does not format correctly
   * @param ssn the ssn to format and patch into the form
   */
  ssnFix(ssn) {
    if (this.chosenParameter.verboseName === this.i18.searchParameters.person.ssn) {
      if (this.chosenParameter.chosenOperator.verboseName === this.i18.searchParameters.operators.endsWith && ssn.length > 4 && ssn[ssn.length-5] != "-") {
        ssn = ssn.substring(0, ssn.length-4) + "-" + ssn.slice(ssn.length-4);
      } else if(ssn.length > 4 && ssn[ssn.length-5] != "-" && (ssn.length === 12 || ssn.length === 10)) {
        ssn = ssn.substring(0, ssn.length-4) + "-" + ssn.slice(ssn.length-4);
      }
      if (this.chosenParameter.chosenOperator.verboseName === this.i18.searchParameters.operators.beginsWith) {
        if(ssn.substring(0,2) != "19" && ssn.substring(0,2) != "20") {
          if(ssn.replace("-", "").trim()[0] < 3) {
            ssn = "20" + ssn;
          } else {
            ssn = "19" + ssn;
          }
        }
      } else if(ssn.replace("-", "").trim().length === 10) {
        let ssnStr = ssn;
        if(ssnStr.includes('-')){
          let tmpSplit = ssnStr.split('-');
          while(tmpSplit[1].length < 4){
            tmpSplit[1] += 'X';
          }
          ssnStr = tmpSplit[0] + '-' + tmpSplit[1];
          ssn = ssnStr;
        }
        else if(ssn.replace("-", "").trim()[0] < 3) {
          ssn = "20" + ssn;
        } else {
          ssn = "19" + ssn;
        }
      }
      if(ssn.slice(ssn.length-2) === "tf") {
        ssn = ssn.substring(0, ssn.length-2) + "TF";
      }
      this.searchForm.patchValue({
        filterTextInput: ssn
      });
    }
  }

  /**
   * Sets the dropdown for export reportlist with avaliable departments
   * @param data departement
   */
  setDepartmentsList(data){
    if(this.departmentsList.length > 0){
      this.departmentsList = [];
    }
    if(data.length > 0) {
      data.sort((departement1, departement2) => departement1.ministryName.localeCompare(departement2.ministryName, 'sv', {sensitivity: 'case'}));
      data.unshift({id: "0", ministryName: this.i18.goverment.form.govermentNotSelected, govEntity: []})
      this.departmentsList.push(data)
    }
    else {
      this.departmentsList.push([{id: "0", ministryName: this.i18.goverment.form.govermentNotSelected, govEntity: []}])
    }    
  }

  /**
   * set the various export information parameters displayed in the export modal
   * @param status array of exportData
   */
  calculateExports(status: any){
    let total = 0;
    let failed = 0;
    let successfull = 0;
    let missing = 0;
    status.forEach(element => {
      total += element.totalExported;
      failed += element.failedExport;
      missing = element.missingInformation;
      successfull += element.successfulExport;
    });

    this.totalExported = total;
    this.failedExport = failed;
    this.successfullExport = successfull;
    this.missingInformation = missing;
  }

  setLastViewedPage(page: any) {
    this.lastViewedPage = page;
  }

  setAnchor(anchor: string){
    this.lastViewedAnchor = anchor;
    localStorage.setItem('lastViewedAnchor', JSON.stringify(this.lastViewedAnchor));
  }

  clearAnchor() {
    this.lastViewedAnchor = '';
    this.scrollToAnchor = false;
    this.lastViewedPage = 1;
    localStorage.removeItem('lastViewedAnchor');
  }

  ngAfterViewChecked(){
    if(!this.scrollToAnchor && this.lastViewedAnchor != null && this.lastViewedAnchor !== '') {
      this.scrollToAnchor = this.appService.scrollToTargetBoolean(this.lastViewedAnchor);
    }
  }
  
  /**
   * Helper to autocomplete a date with missing dividers '-'
   * @param date date string to patch
   * @param form the form to use
   * @param formControlName the formControlName to be patched with the date.
   */
  patchDate(date: string, form: string, formControlName: string) {
      if(date != null) {
          date = date.replace(/-/g,'');
      }
      if((date != null && date.trim() !== '') && 
      (formControlName != null && formControlName.trim() !== '') && date.length >= 8) {
          let yearPossition = 4;
          let monthPossition = 6;
          let dateDivader = '-'
          let patchedDate = date.substring(0,yearPossition) + dateDivader + date.substring(yearPossition, monthPossition) + dateDivader + date.substring(date.length-2, date.length)
          if(form === 'searchForm') {
              this.searchForm.patchValue({
                  [formControlName]: patchedDate
              })
          }
      }
  }
}
